import { keyBy } from 'lodash';

export const NON_CREDIT_CARD_PAYMENTS = [
	'COD',
	'BillMeLater',
	'PayLater',
	'PayInStore',
	'Oxxo',
	'OpenPay',
	'PayPal',
];
export const NON_CC_PAYMENTS_BY_CODE = keyBy(NON_CREDIT_CARD_PAYMENTS);
